import React, { useState, useEffect } from 'react'
import Form from './Form'
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function Create({BTNLabel="", Header="", Subheader="", PopupID="Example", is_edit, setIsEdit, edit_id, setEditId, is_add_edit_option=true }) {
    const [canCreate, setCanCreate] = useState(false);

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
            } else {
                const createAllowed = await hasPermission("SETTINGS", "NoticeBoard", "CREATE");
                setCanCreate(createAllowed);
            }
        };
        checkPermissions();
    }, []);

    return (
        <>
        {
            (is_add_edit_option && canCreate) ?
            <button className="btn btn-secondary create-new btn-primary" type="button" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(false);setEditId(0);}}>
                <span>
                    <i className="ti ti-plus me-sm-1"></i>
                    <span className="d-none d-sm-inline-block">{BTNLabel}</span>
                </span>
            </button>
            : ''
        }

            <div className="modal fade" id={`${PopupID}`} tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-simple modal-edit-user">
                    <div className="modal-content p-3 p-md-5">
                        <div className="modal-body">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="text-center mb-4">
                                <h3 className="mb-2">{`${Header}`}</h3>
                                <p className="text-muted">{`${Subheader}`}</p>
                            </div>
                            <Form is_edit={is_edit} edit_id={edit_id} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
